module.exports = __webpack_public_path__ + "./images/6247e2296418a04fd5485906ce865942.webp";